var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledFloatingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#0A229D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 14H18.3333C17.4493 14 16.6014 14.3477 15.9763 14.9665C15.3512 15.5854 15 16.4248 15 17.3V32.7C15 33.5752 15.3512 34.4146 15.9763 35.0335C16.6014 35.6523 17.4493 36 18.3333 36H31.6667C32.5507 36 33.3986 35.6523 34.0237 35.0335C34.6488 34.4146 35 33.5752 35 32.7V23.9H28.3333C27.4493 23.9 26.6014 23.5523 25.9763 22.9335C25.3512 22.3146 25 21.4752 25 20.6V14ZM35 21.7V21.5108C34.9995 20.636 34.6482 19.7973 34.0233 19.1788L29.77 14.9658C29.1448 14.3473 28.2972 13.9999 27.4133 14H27.2222V20.6C27.2222 20.8917 27.3393 21.1715 27.5477 21.3778C27.756 21.5841 28.0386 21.7 28.3333 21.7H35Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledFloatingIcon);
export default __webpack_public_path__ + "static/media/Filled-floating-icon.f4e2169bcbf633e5a80bdbcef90e1cc7.svg";
export { ForwardRef as ReactComponent };